import React from 'react';
import LeftRight from "../../components/ui/LeftRight";
import s1 from "../../assets/images/products/pages/weeds/1.png";
import s2 from "../../assets/images/products/pages/weeds/2.png";
import s3 from "../../assets/images/products/pages/weeds/3.png";
import s4 from "../../assets/images/products/pages/weeds/4.png";
import { useTranslation } from "react-i18next";
import {weedsBlackBox} from "../../constants/meta";
import Meta from "../../components/common/Helmet";

const WeedsBlackBoxSuite = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Meta
        title={weedsBlackBox.title}
        description={weedsBlackBox.description}
        canonical={weedsBlackBox.canonical}
        keywords={weedsBlackBox.keywords}
        ogTitle={weedsBlackBox.title}
        ogDescription={weedsBlackBox.description}
      />
      <div className="md:w-theme-container w-mobile-container mx-auto py-12 space-y-16">
        <LeftRight
          title={t('weedsPage.weedsBlackBoxSuite')}
          isLeft={true}
          textWidthClass={'md:w-1/2'}
          textPosition={'justify-center'}
          descriptionPosition={'text-center'}
          descriptionList={[
            t('weedsPage.weedsDesc1')
          ]}
          icon={false}
          image={s1}
        />
        <LeftRight
          isLeft={false}
          textPosition={'justify-start'}
          descriptionPosition={'text-left'}
          title={t('weedsPage.humanErrorCause')}
          descriptionList={[
            t('weedsPage.importanceOfHumanBehavior'),
            t('weedsPage.weedsBlackBoxIntro')
          ]}
          icon={false}
          image={s2}
        />
        <LeftRight
          isLeft={true}
          textPosition={'justify-start'}
          descriptionPosition={'text-left md:text-md'}
          title={t('weedsPage.questionNeedVisibility')}
          descriptionList={[
            t('weedsPage.questionNeedMonitoring'),
            t('weedsPage.questionNeedEDiscovery'),
            t('weedsPage.questionNeedCompliance'),
            t('weedsPage.questionNeedRiskManagement'),
            t('weedsPage.questionNeedThreatMonitoring'),
            t('weedsPage.questionSystemLimitations'),
            t('weedsPage.questionNeedLogManagement'),
          ]}
          icon={true}
          image={s3}
        />
        <LeftRight
          isLeft={false}
          textPosition={'justify-start'}
          descriptionPosition={'text-left md:text-md'}
          title={t('weedsPage.systemsNotAtFault')}
          descriptionList={[
            t('weedsPage.limitationsOfCurrentSecurity')
          ]}
          icon={true}
          image={s4}
        />
        <div className="text-center text-2xl font-medium mb-2">
          {t('common.products')}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className="bg-red-3000 flex items-center justify-center p-4 rounded">
              <img
                src={require(`../../assets/images/products/pages/weeds/screen/product_bb_ui_${index + 1}.png`)}
                alt=""
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WeedsBlackBoxSuite;
